import React from "react";
import FontIcon from "react-md/lib/FontIcons";
import Link from "gatsby-link";

function GetNavList() {
  const NavList = [
    {
      primaryText: "Home",
      leftIcon: <FontIcon>home</FontIcon>,
      component: Link,
      to: "/"
    },
    {
      primaryText: "Community",
      leftIcon: <FontIcon>people</FontIcon>,
      component: Link,
      to: "/community"
    },
    {
      primaryText: "Contact Us",
      leftIcon: <FontIcon>contacts</FontIcon>,
      component: Link,
      to: "/contact"
    }
  ];
  return NavList;
}
export default GetNavList;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavList.jsx